import * as React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import AddCategoryBtn from './AddCategoryBtn';
import { useGetAllExpanceQuery } from '@/store/expancesApi';
import { useGetExpenseCategoryQuery } from '@/store/ExpenseCategoryApi';
import { useSelector } from 'react-redux';
import { RootState } from '@/types';
import FilterDropdown from './FilterDropdown';
import ExpenseFormDialog from '../ExpenseFormDialog';
import useSearchExpanse from '@/hooks/useSearchExpanse';
import ExpanseCategories from './ExpanseCategories';
import RecentTransactions from './RecentTransactions';
import ExpanseFilterSection from './ExpanseFilterSection';
import FeaturedSections from './FeaturedSections';

const AdminExpenseDashboard = () => {
  const { user } = useSelector((state: RootState) => state.user);
  const { data: allExpanses } = useGetAllExpanceQuery(user?.token);
  const { data: allLedger } = useGetExpenseCategoryQuery(user?.token);
  const [searchTerm, setSearchTerm] = React.useState('');
  const [filteredExpenses, setFilteredExpenses] = React.useState('');
  const [isOpen, setIsOpen] = React.useState(false);
  const [editData, setEditData] = React.useState(null);

  const { filterBySearchTerm } = useSearchExpanse(
    allExpanses,
    searchTerm,
    filteredExpenses
  );

  return (
    <div className="p-6 max-w-7xl mx-auto">
      {/* Header Section */}
      <div className="mb-8">
        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-6">
          <h1 className="text-2xl font-bold text-foreground mb-4 sm:mb-0">
            Expense Management
          </h1>
          <div className="flex flex-wrap gap-3">
            <AddCategoryBtn />
            <ExpenseFormDialog
              open={isOpen}
              setOpen={setIsOpen}
              editExpense={editData}
              setEdit={setEditData}
            />
          </div>
        </div>

        {/* Filter Section */}
        <ExpanseFilterSection
          filterBySearchTerm={filterBySearchTerm}
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
        />
      </div>

      {/* Expense Cards Grid */}
      <ExpanseCategories allExpanses={allExpanses} allLedger={allLedger} />

      <Card className="mb-8">
        <CardContent className="p-6">
          <div className="md:flex justify-between items-center mb-6">
            <h2 className="text-xl font-semibold">Recents Transactions</h2>

            <FilterDropdown
              categories={allLedger}
              setFilter={setFilteredExpenses}
            />
          </div>
          <RecentTransactions
            filterBySearchTerm={filterBySearchTerm}
            setEditData={setEditData}
            setIsOpen={setIsOpen}
          />
        </CardContent>
      </Card>

      <FeaturedSections />
    </div>
  );
};

export default AdminExpenseDashboard;
